module.exports = __webpack_public_path__ + "img/12.19914269.jpg";